import { PlayerRichAudioBar } from "../PlayerAudioBar/PlayerRichAudioBar";
import { PlayerSimpleAudioBar } from "../PlayerAudioBar/PlayerSimpleAudioBar";
import { timelineMode } from "../TimelineModePicker";

import { useBaseStore } from "@/store/store";

import { PlayerTimelinePickerProps } from ".";

export function PlayerTimelinePicker({
  color,
  speakers,
}: PlayerTimelinePickerProps) {
  const mode = useBaseStore((store) => store.mode);

  // Should be unreachable since we check if call is voicemail in Dropdown hook picker.
  if (!speakers) {
    return <PlayerSimpleAudioBar color={color} />;
  }

  switch (mode) {
    case timelineMode.simple:
      return <PlayerSimpleAudioBar color={color} />;
    case timelineMode.karaoke:
      return <PlayerRichAudioBar color={color} speakers={speakers} />;
    case timelineMode.sentiments:
      return <PlayerRichAudioBar color={color} speakers={speakers} />;
    default:
      return null;
  }
}
